import { render } from "./InternalNotes.vue?vue&type=template&id=3606f696&scoped=true"
import script from "./InternalNotes.vue?vue&type=script&lang=js"
export * from "./InternalNotes.vue?vue&type=script&lang=js"

import "./InternalNotes.vue?vue&type=style&index=0&id=3606f696&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3606f696"]])

export default __exports__